import { useSimpleList } from "@refinedev/antd";
import { Grid, Skeleton, Typography } from "@mui/material";

import { CanvasTile } from "components/canvas";
import { SponsorsBanner } from "components/banners";
import { Canvas } from "types";

export const CanvasFeaturedList: React.FC = () => {
  const { listProps, queryResult } = useSimpleList<Canvas>({
    resource: "canvases",
    pagination: {
      pageSize: 12,
    },
    sorters: {
      initial: [
        {
          field: "created_at",
          order: "desc",
        },
      ],
    },
    filters: {
      initial: [
        {
          field: "is_featured",
          operator: "eq",
          value: true,
        },
      ],
    },
  });

  const { isLoading } = queryResult;

  return (
    <div className="container">
      <div className="paper">
        {isLoading ? (
          <div className="canvas-skeleton-list">
            {[...Array(12)].map((_, index) => (
              <Skeleton key={index} animation="wave" />
            ))}
          </div>
        ) : (
          <Grid
            container
            className="canvas-list"
            direction="row"
            justifyContent="center"
            columns={3}
            gap={1}
          >
            {!!listProps?.dataSource?.length ? (
              listProps?.dataSource?.map((canvas, idx) => (
                <CanvasTile key={idx} canvas={canvas} />
              ))
            ) : (
              <Typography
                variant="body1"
                color="GrayText"
                fontWeight="semibold"
                textAlign="center"
                mx="auto"
              >
                No Canvas are featured yet!.
              </Typography>
            )}
          </Grid>
        )}
      </div>
      <SponsorsBanner />
    </div>
  );
};
